import React from "react"
import { useSelector } from "react-redux"
import { isFeatureEnabled } from "reduxSlices/featuresSlice"
import { hasConversations } from "reduxSlices/formSubmissionConversationsSlice"
import { submitterFullName, tracked } from "reduxSlices/formSubmissionSlice"
import { CONVERSATIONS } from "utils/featuresHelpers"

function SubmissionEditFormDisclaimer() {
  const conversationsEnabled = useSelector(isFeatureEnabled(CONVERSATIONS))
  const isTracked = useSelector(tracked)
  const submitterName = useSelector(submitterFullName)
  const submissionHasConversations = useSelector(hasConversations)

  if (!conversationsEnabled || !isTracked) return null

  if (submissionHasConversations) {
    return (
      <p className="text-xs text-dark">
        Your changes to this form submission will be visible to the submitter, {submitterName}.
        Because a conversation has been opened, the submitter can view the current answers until
        this form submission is closed.
      </p>
    )
  }

  return (
    <p className="text-xs text-dark">
      If a conversation is opened on this form submission, your changes will become visible
      to the submitter, {submitterName}, until the form submission is closed.
    </p>
  )
}

export default SubmissionEditFormDisclaimer
